/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { useContext } from 'react';

import WebExtensionContext from './context';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useWebExtension = () => {
	const webExtension = useContext(WebExtensionContext);
	return webExtension;
};

export default useWebExtension;
